module.exports = __webpack_public_path__ + "html/banner_bc5f360f3129765b964e7a2da5f0fe34.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/landing/banner.html
// module id = IU0M
// module chunks = 153